export const CANADIAN_LOCATIONS = [
  {
    province: 'Alberta',
    abbreviation: 'AB',
    cities: ['Calgary', 'Edmonton', 'Red Deer', 'Lethbridge', 'Medicine Hat', 'Grande Prairie', 'Airdrie', 'Spruce Grove', 'St. Albert'],
  },
  {
    province: 'British Columbia',
    abbreviation: 'BC',
    cities: ['Vancouver', 'Victoria', 'Surrey', 'Burnaby', 'Richmond', 'Kelowna', 'Kamloops', 'Nanaimo', 'Abbotsford', 'Prince George'],
  },
  {
    province: 'Manitoba',
    abbreviation: 'MB',
    cities: ['Winnipeg', 'Brandon', 'Steinbach', 'Thompson', 'Portage la Prairie', 'Winkler'],
  },
  {
    province: 'New Brunswick',
    abbreviation: 'NB',
    cities: ['Moncton', 'Fredericton', 'Saint John', 'Dieppe', 'Miramichi', 'Edmundston'],
  },
  {
    province: 'Newfoundland and Labrador',
    abbreviation: 'NL',
    cities: ["St. John's", 'Mount Pearl', 'Corner Brook', 'Gander', 'Grand Falls-Windsor', 'Labrador City'],
  },
  {
    province: 'Nova Scotia',
    abbreviation: 'NS',
    cities: ['Halifax', 'Sydney', 'Dartmouth', 'Truro', 'New Glasgow', 'Kentville', 'Bridgewater'],
  },
  {
    province: 'Ontario',
    abbreviation: 'ON',
    cities: ['Toronto', 'Ottawa', 'Mississauga', 'Brampton', 'Hamilton', 'London', 'Markham', 'Vaughan', 'Kitchener', 'Windsor', 'Oshawa', 'Barrie', 'Kingston', 'Guelph', 'Sudbury', 'Thunder Bay', 'Burlington', 'Oakville', 'Milton', 'Waterloo', 'Cambridge', 'Peterborough'],
  },
  {
    province: 'Prince Edward Island',
    abbreviation: 'PE',
    cities: ['Charlottetown', 'Summerside', 'Stratford', 'Cornwall', 'Montague'],
  },
  {
    province: 'Quebec',
    abbreviation: 'QC',
    cities: ['Montreal', 'Quebec City', 'Laval', 'Gatineau', 'Longueuil', 'Sherbrooke', 'Trois-Rivières', 'Lévis', 'Saguenay', 'Terrebonne'],
  },
  {
    province: 'Saskatchewan',
    abbreviation: 'SK',
    cities: ['Saskatoon', 'Regina', 'Prince Albert', 'Moose Jaw', 'Swift Current', 'Yorkton', 'North Battleford', 'Estevan'],
  },
  {
    province: 'Northwest Territories',
    abbreviation: 'NT',
    cities: ['Yellowknife', 'Hay River', 'Inuvik', 'Fort Smith', 'Behchokǫ̀'],
  },
  {
    province: 'Nunavut',
    abbreviation: 'NU',
    cities: ['Iqaluit', 'Rankin Inlet', 'Arviat', 'Baker Lake', 'Cambridge Bay'],
  },
  {
    province: 'Yukon',
    abbreviation: 'YT',
    cities: ['Whitehorse', 'Dawson City', 'Watson Lake', 'Haines Junction'],
  },
];

export function normalizeLocationSearch(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function buildLocationSuggestions() {
  return CANADIAN_LOCATIONS.flatMap(({ province, abbreviation, cities }) => [
    {
      id: `province-${abbreviation}`,
      type: 'province',
      label: province,
      value: province,
      province,
      provinceAbbreviation: abbreviation,
      city: '',
      searchText: normalizeLocationSearch(`${province} ${abbreviation}`),
    },
    ...cities.map(city => ({
      id: `city-${abbreviation}-${city}`,
      type: 'city',
      label: `${city}, ${province}`,
      value: `${city}, ${province}`,
      province,
      provinceAbbreviation: abbreviation,
      city,
      searchText: normalizeLocationSearch(`${city} ${province} ${abbreviation}`),
    })),
  ]);
}

const LOCATION_SUGGESTIONS = buildLocationSuggestions();

function scoreSuggestion(suggestion, query) {
  if (!query) return suggestion.type === 'province' ? 2 : 1;
  const city = normalizeLocationSearch(suggestion.city);
  const province = normalizeLocationSearch(suggestion.province);
  const abbreviation = normalizeLocationSearch(suggestion.provinceAbbreviation);
  const label = normalizeLocationSearch(suggestion.label);

  if (city === query || province === query || abbreviation === query || label === query) return 100;
  if (city.startsWith(query) || province.startsWith(query)) return 90;
  if (label.startsWith(query)) return 80;
  if (suggestion.searchText.includes(query)) return 70;
  return 0;
}

export function getLocationSuggestions(query, limit = 24) {
  const normalizedQuery = normalizeLocationSearch(query);
  return LOCATION_SUGGESTIONS
    .map(suggestion => ({ ...suggestion, score: scoreSuggestion(suggestion, normalizedQuery) }))
    .filter(suggestion => suggestion.score > 0)
    .sort((a, b) => b.score - a.score || a.label.localeCompare(b.label))
    .slice(0, limit);
}